import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useNetRevenueSummaryV2 = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.netRevenueSummaryV2, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getNetRevenueSummaryV2(), {
        params,
      });

      const composeResponse = {
        clinicNetRevenue: res.data.data.report.clinic_net_revenue_summary,
        providerNetRevenue: res.data.data.report.provider_net_revenue_summary,
      };
      return composeResponse;
    },
    options,
  );
};
